import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~fetchs/useCliente";
import NavTabs from '~components/NavTabs'
import '~components/Search/styles.scss'
import FunnelClientSearch from './FunnelClientSearch'

const TABS = [
  { name: 'Próximas Negociações', link: '/funil-de-obras/proximas-negociacoes' },
  { name: 'Obras Ganhas', link: '/funil-de-obras/obras-ganhas' },
]

const FunnelLayout = ({children, id, navs = TABS, showSearch = false,  onSearch,  placeholder = 'Buscar Cliente, Razão Social e Grupo Centralizador',}) => {
    const { cliente } = useCliente(id);
    const handleSearch = (value) => {}

    return (
        <div data-testid="layout-container" className="container ">
            <ClientHeader dados={cliente} />

            <NavTabs navs={navs} />
            <FunnelClientSearch showSearch onSearch={onSearch} placeholder={placeholder} />
            
            {children}
        </div>
    )
}

export default FunnelLayout;